<template>
    <div>
        <Field v-model="content" :field="field" @error="error" v-bind="$attrs" :extendErrors="errors"/>
        <slot></slot>
    </div>
</template>

<script>
import IdentityFields from '../identityFields/IdentityFields'

export default {
    name: 'Input',
    components: {
        Field: IdentityFields
    },
    props: {
        label: {
            type: String
        },
        value: {
            type: String | Number
        },
        name: {
            type: String
        },
        rules: {
            type: Object
        },
        type: {
            type: String,
            default: 'text'
        },
        description: {
            type: String,
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            field: {
                type: this.type,
                module: "input",
                key: this.name,
                name: this.label,
                description: this.description,
                constraints: this.rules
            }
        }
    },
    computed: {
        constraints() {
            let rules = this.rules

            return rules
        },
        content: {
            get() {
                let valObj = {}
                valObj[this.field.key] = this.value

                return valObj
            },

            set(val) {
                if (this.rules.expression !== undefined) {
                    this.errors = this.rules.expression(val)
                    this.error({
                        field: this.name,
                        error: this.errors.length > 0
                    })
                }

                this.$emit('input', val[this.field.key])
            }
        }
    },
    methods: {
        error(errors) {
            this.$emit('error', errors)
        }
    }
}
</script>